// DUCKS pattern
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiBaseUrl } from "../../config";
import { ResponseModel } from "../../models/apiModels";
import { RootState } from "../store";

export interface CategoryLookupModel {
  key: string;
  value: string;
}

export interface CategoryModel {
  id: string;
  name: string;
  description?: string;
  logo?: string;
  image?: string;
}

export interface CategoryAdCopy {
  headline: string;
  description: string;
  adImage: string;
  mainHeadline: string;
  subHeadline?: string;
}

export interface CategoryState {
  categoryDetail?: CategoryModel;
  categoryAdCopy?: CategoryAdCopy;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: CategoryState = {
  status: "idle",
  error: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    resetData(state) {
      state.categoryDetail = undefined;
      state.categoryAdCopy = undefined;
      state.error = null;
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder
      // #region GetEstimate
      .addCase(getCategoryDetail.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getCategoryDetail.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categoryDetail = action.payload;
      })
      .addCase(getCategoryDetail.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || null;
      })
      .addCase(getCategoryAdCopy.fulfilled, (state, action) => {
        state.categoryAdCopy = action.payload;
      });
    // #endregion
  },
});
export const { resetData } = categorySlice.actions;
export default categorySlice.reducer;

export const selectCategoryState = (state: RootState) => state.category;

export const selectStatus = (state: RootState) => state.category.status;

export const getCategoryDetail = createAsyncThunk(
  "category/searchCategories",
  async (categoryId: string) => {
    const newUrl = new URL(`${ApiBaseUrl}/category/${categoryId}`);

    const response = await fetch(newUrl.href);

    const responseJson: ResponseModel<CategoryModel> = await response.json();
    return responseJson.result;
  }
);

export const getCategoryAdCopy = createAsyncThunk(
  "category/getCategoryAdCopy",
  async (categoryId: string | undefined) => {
    if (categoryId) {
      const newUrl = new URL(`${ApiBaseUrl}/category/${categoryId}/GetDefaultAdCopy`);
      
      const response = await fetch(newUrl.href);

      const responseJson: ResponseModel<CategoryAdCopy> = await response.json();
      return responseJson.result;
    }
  }
);
